var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 11.375C20.125 9.05436 19.2031 6.82876 17.5622 5.18782C15.9212 3.54687 13.6956 2.625 11.375 2.625C9.05436 2.625 6.82876 3.54687 5.18782 5.18782C3.54687 6.82876 2.625 9.05436 2.625 11.375C2.625 13.6956 3.54687 15.9212 5.18782 17.5622C6.82876 19.2031 9.05436 20.125 11.375 20.125C13.6956 20.125 15.9212 19.2031 17.5622 17.5622C19.2031 15.9212 20.125 13.6956 20.125 11.375ZM18.4352 20.2945C16.4992 21.8313 14.0437 22.75 11.375 22.75C5.09141 22.75 0 17.6586 0 11.375C0 5.09141 5.09141 0 11.375 0C17.6586 0 22.75 5.09141 22.75 11.375C22.75 14.0437 21.8313 16.4992 20.2945 18.4352L27.6172 25.7578C28.1313 26.2719 28.1313 27.1031 27.6172 27.6117C27.1031 28.1203 26.2719 28.1258 25.7633 27.6117L18.4352 20.2945Z",
    fill: "#B7B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c2a818e4271e7fcb34acbb0be2ed0872.svg";
export { ForwardRef as ReactComponent };